module.exports = __webpack_public_path__ + "e2c4a9601b105904ed908b3b06ace9a1.png";